import React from "react";
import { FiPlus, FiGrid } from "react-icons/fi";
import JoditEditor from "jodit-react";

export default function Step1SectionMeta({
  sectionData,
  setSectionData,
  onNext,
}) {
  return (
    <div className="max-w-xl mx-auto space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <FiGrid size={32} />
        </div>
        <h3 className="text-xl font-bold text-gray-800">New Section Details</h3>
        <p className="text-gray-500 text-sm">
          Define the structure of this section
        </p>
      </div>

      <div className="space-y-4">
        <InputGroup
          label="Section Name"
          placeholder="e.g. Physics - Mechanics"
          value={sectionData.sectionName}
          onChange={(e) =>
            setSectionData({ ...sectionData, sectionName: e.target.value })
          }
        />

        <div className="mt-6 p-5 rounded-2xl border border-blue-100 bg-blue-50/40">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                id="section-paragraph"
                checked={sectionData.paragraph.isParagraph}
                onChange={(e) =>
                  setSectionData({
                    ...sectionData,
                    paragraph: {
                      ...sectionData.paragraph,
                      isParagraph: e.target.checked,
                    },
                  })
                }
                className="w-4 h-4 accent-blue-600 cursor-pointer"
              />
              <label
                htmlFor="section-paragraph"
                className="text-sm font-semibold text-gray-700 cursor-pointer"
              >
                This section contains a passage (Paragraph-based)
              </label>
            </div>

            {sectionData.paragraph.isParagraph && (
              <span className="text-[10px] uppercase font-bold px-2 py-1 rounded-full bg-blue-100 text-blue-600">
                Paragraph Enabled
              </span>
            )}
          </div>

          {/* Paragraph Editor */}
          {sectionData.paragraph.isParagraph && (
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
              <div className="px-4 py-2 border-b border-gray-100 text-xs font-bold text-gray-500 uppercase">
                Section Paragraph / Passage
              </div>

              <JoditEditor
                value={sectionData.paragraph.text}
                onChange={(content) =>
                  setSectionData({
                    ...sectionData,
                    paragraph: {
                      ...sectionData.paragraph,
                      text: content,
                    },
                  })
                }
              />
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-bold text-gray-600 ml-1">
              Difficulty
            </label>
            <select
              value={sectionData.difficulty}
              onChange={(e) =>
                setSectionData({ ...sectionData, difficulty: e.target.value })
              }
              className="px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 outline-none bg-white text-gray-700"
            >
              <option value="easy">Easy</option>
              <option value="medium">Medium</option>
              <option value="hard">Hard</option>
            </select>
          </div>

          {/* <InputGroup
            label="Total Questions"
            type="number"
            min="1"
            value={sectionData.totalQuestions}
            onChange={(e) =>
              setSectionData({
                ...sectionData,
                totalQuestions: parseInt(e.target.value) || 0,
              })
            }
          /> */}
        </div>
      </div>

      <button
        onClick={onNext}
        className="w-full py-3.5 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg flex items-center justify-center gap-2 mt-4"
      >
        Continue <FiPlus />
      </button>
    </div>
  );
}

function InputGroup({ label, ...props }) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-bold text-gray-600 ml-1">{label}</label>
      <input
        {...props}
        className="px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none bg-white text-gray-700"
      />
    </div>
  );
}
